import { Link } from 'react-router-dom';
import { t } from '../../content';
import WriteAccessGuard from '../reusableElementsComponents/WriteAccessGuard';


function NoDataOpenPositions() {
    return (
            <div className="open-positions-no-data">
                <h1>{t('emptyStates.openPositions.title')}</h1>
                <h4 className="semi-bold header-text header">{t('emptyStates.openPositions.title')}</h4>
                <p className="grey s center action-text description">{t('emptyStates.openPositions.description')}</p>
                <WriteAccessGuard>
                    <button className="mazhrBtn default-green">
                        <Link to="/new-open-position" className="semi-bold white">
                            {t('emptyStates.openPositions.cta')}
                        </Link>
                    </button>
                </WriteAccessGuard>
            </div>
        )
}

export default NoDataOpenPositions;
